// services/globalActionsService.ts

import { GlobalAction } from '../types/GlobalAction';

const API_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE = `${API_URL}/actionglobals`;

export interface ListGlobalActionsResponse{
  records: GlobalAction[]
}

export const globalActionsService = {

  list: async (sdg: number): Promise<ListGlobalActionsResponse> => {
    const res = await fetch(`${API_BASE}/bysdg/${sdg}`);
    if (!res.ok) throw new Error('Failed to fetch global actions');
    return res.json();
  },

  get: async (id: string): Promise<GlobalAction> => {
    const res = await fetch(`${API_BASE}/${id}`);
    if (!res.ok) throw new Error('Failed to fetch global action');
    return res.json();
  },

  create: async (action: Partial<GlobalAction>): Promise<GlobalAction> => {
    const res = await fetch(API_BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(action),
    });
    if (!res.ok) throw new Error('Failed to create global action');
    return res.json();
  },

  update: async (id: string, updates: Partial<GlobalAction>): Promise<GlobalAction> => {
    const res = await fetch(`${API_BASE}/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates),
    });
    if (!res.ok) throw new Error('Failed to update global action');
    return res.json();
  },

  remove: async (id: string): Promise<void> => {
    const res = await fetch(`${API_BASE}/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to delete global action');
  },
};
